import React from "react";
import {NavLink, Outlet, useParams} from "react-router-dom";
import SectionHeading from "../../../../components/SectionHeading";

type StepKey = "details" | "images" | "play-categories" | "data-collection" | "review";

const STEPS: Array<{key: StepKey; label: string; to: string}> = [
    {key: "details", label: "Details", to: "details"},
    {key: "images", label: "Images", to: "images"},
    {key: "play-categories", label: "Play Categories", to: "play-categories"},
    {key: "data-collection", label: "Data Collection", to: "data-collection"},
    {key: "review", label: "Review & Publish", to: "review"},
];

const cx = (...c: Array<string | false | null | undefined>) => c.filter(Boolean).join(" ");

export default function ManageTournamentLayout() {
    const params = useParams();

    const tournamentId = params.tournamentId ?? null;
    const basePath = `/business/tournaments/${encodeURIComponent(tournamentId ?? "")}/edit`;

    return (
        <div className="space-y-6">
            <SectionHeading
                title="Manage Tournament"
                description="Set up your tournament details, images, registration, and custom fields."
            />

            <div className="mt-10 border-b border-gray-200">
                <nav
                    className="-mb-px flex gap-4 overflow-x-auto scrollbar-hide sm:gap-6"
                    aria-label="Tabs"
                >
                    {STEPS.map((s) => (
                        <NavLink
                            key={s.key}
                            to={`${basePath}/${s.to}`}
                            className={({isActive}) =>
                                cx(
                                    "shrink-0 whitespace-nowrap border-b-2 pb-3",
                                    "px-2 text-xs font-medium sm:px-1 sm:text-sm",
                                    isActive
                                        ? "border-orange-600 text-orange-700"
                                        : "border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-300"
                                )
                            }
                        >
                            {s.label}
                        </NavLink>
                    ))}
                </nav>
            </div>

            <div className="flex gap-6 items-start">
                <div className="flex-1 min-w-0">
                    <Outlet context={{tournamentId, isEdit: true}}/>
                </div>
            </div>
        </div>
    );
}
